var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('multiselect',{attrs:{"options":_vm.options,"placeholder":"Type to search","track-by":"ID","label":"name","max-height":125,"allow-empty":_vm.allowEmpty,"multiple":_vm.isMultiple,"custom-label":_vm.customLabel},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }